<template>
  <el-date-picker
    @change="changeHanlder"
    v-model="selectValue"
    type="daterange"
    align="right"
    unlink-panels
    range-separator="至"
    start-placeholder="开始日期"
    end-placeholder="结束日期"
    :picker-options="pickerOptions"
    format="yyyy-MM-dd"
    value-format="yyyy-MM-dd"
    editable
    :clearable="clearable"
    style="width: 240px"
  >
  </el-date-picker>
</template>

<script>
export default {
  name: "DateRangePicker",
  props: {
    minVal: [Number, String],
    maxVal: [Number, String],
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    minVal: {
      handler(val) {
        if (this.minVal && this.maxVal) {
          this.selectValue = [this.minVal, this.maxVal];
        } else {
          this.selectValue = null;
        }
      },
      immediate: true,
    },
    maxVal: {
      handler(val) {
        if (this.minVal && this.maxVal) {
          this.selectValue = [this.minVal, this.maxVal];
        } else {
          this.selectValue = null;
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      selectValue: null,
      pickerOptions: {
        shortcuts: [
          {
            text: "本月",
            onClick(picker) {
              picker.$emit("pick", [
                new Date(new Date().getFullYear(), new Date().getMonth(), 1),
                new Date(),
              ]);
            },
          },
          {
            text: "今年至今",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近六个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  methods: {
    changeHanlder(val) {
      this.$emit("update:minVal", val && val[0] ? val[0] : null);
      this.$emit("update:maxVal", val && val[1] ? val[1] : null);
      this.$emit("change", val);
    },
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/fm/DateRangePicker.vue